import { render } from "./Amenities.vue?vue&type=template&id=07762da9&scoped=true"
import script from "./Amenities.vue?vue&type=script&lang=js"
export * from "./Amenities.vue?vue&type=script&lang=js"

import "./Amenities.vue?vue&type=style&index=0&id=07762da9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07762da9"]])

export default __exports__